/**
 * React Query key factory for the Dispatch Board.
 *
 * Keep keys deeply hierarchical so partial invalidation works naturally:
 *   - `invalidateQueries({ queryKey: dispatchKeys.all })` blasts everything
 *   - `invalidateQueries({ queryKey: dispatchKeys.day(date) })` refreshes one day
 */

export const dispatchKeys = {
  all: ['dispatch-board'] as const,
  day: (date: string) => [...dispatchKeys.all, 'day', date] as const,
  /** End-of-day capture status snapshot (Phase 7g). */
  captureSummary: (date: string) =>
    [...dispatchKeys.all, 'capture-summary', date] as const,
};
